import React, { ChangeEvent } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import classnames from 'classnames/bind';
import styles from '../career.module.scss';
const cx = classnames.bind(styles);

const maxLength = 10000;

type PerformanceProps = UseControllerProps;
const Performance = (props: PerformanceProps) => {
  const { field } = useController(props);

  const length = field.value?.length ?? 0;

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) return;
    field.onChange(e.target.value);
  };

  return (
    <div className={cx('textareaWrap')}>
      <textarea
        {...field}
        placeholder="주요 성과를 간략하게 설명해주세요."
        maxLength={10000}
        rows={4}
        onChange={onChange}
      />
      <div className={cx('infoText')}>
        최대 글자수 : <span className={cx('value')}>{length}</span> / {maxLength}
      </div>
    </div>
  );
};

export default Performance;
